"use client";

import { useState } from "react";
import { Icon } from "./Icons";
import { Field } from "./UI";

export default function AuthScreen({ needsSetup, onSubmit, loading, error }) {
  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirm: ""
  });
  const [localError, setLocalError] = useState("");

  const update = (key) => (event) =>
    setForm((current) => ({ ...current, [key]: event.target.value }));

  async function submit(event) {
    event.preventDefault();
    setLocalError("");
    if (needsSetup && form.password !== form.confirm) {
      setLocalError("Passwords do not match.");
      return;
    }
    if (form.password.length < 8) {
      setLocalError("Use at least 8 characters for the password.");
      return;
    }
    await onSubmit(form);
  }

  return (
    <main className="auth-screen">
      <section className="auth-brand">
        <div className="brand-mark brand-mark-large">F</div>
        <span className="eyebrow eyebrow-light">Hotel operations, simplified</span>
        <h1>Felix Rate Desk</h1>
        <p>
          Price rooms confidently, see availability at a glance, and keep the
          front desk in sync.
        </p>
        <div className="auth-feature-list">
          <span>
            <Icon name="calculator" /> Three clear pricing scenarios
          </span>
          <span>
            <Icon name="calendar" /> Reservations and availability
          </span>
          <span>
            <Icon name="device" /> Designed for iPhone and iPad
          </span>
        </div>
      </section>

      <section className="auth-panel">
        <form className="auth-card" onSubmit={submit}>
          <div className="auth-card-heading">
            <span className="eyebrow">
              {needsSetup ? "First-time setup" : "Welcome back"}
            </span>
            <h2>{needsSetup ? "Create the owner account" : "Sign in"}</h2>
            <p>
              {needsSetup
                ? "This first account can manage rooms, prices, reservations and staff."
                : "Use your hotel account to continue."}
            </p>
          </div>

          {needsSetup ? (
            <Field label="Your name">
              <input
                autoComplete="name"
                onChange={update("name")}
                placeholder="Property manager"
                required
                value={form.name}
              />
            </Field>
          ) : null}

          <Field label="Email address">
            <input
              autoCapitalize="none"
              autoComplete="email"
              inputMode="email"
              onChange={update("email")}
              placeholder="you@hotel.com"
              required
              type="email"
              value={form.email}
            />
          </Field>

          <Field label="Password">
            <input
              autoComplete={needsSetup ? "new-password" : "current-password"}
              minLength={8}
              onChange={update("password")}
              placeholder="At least 8 characters"
              required
              type="password"
              value={form.password}
            />
          </Field>

          {needsSetup ? (
            <Field label="Confirm password">
              <input
                autoComplete="new-password"
                minLength={8}
                onChange={update("confirm")}
                placeholder="Repeat your password"
                required
                type="password"
                value={form.confirm}
              />
            </Field>
          ) : null}

          {localError || error ? (
            <div className="inline-alert inline-alert-error">
              <Icon name="warning" />
              <span>{localError || error}</span>
            </div>
          ) : null}

          <button className="button button-primary button-full" disabled={loading}>
            {loading
              ? "Please wait…"
              : needsSetup
                ? "Create owner account"
                : "Sign in"}
          </button>

          <p className="auth-security">
            <Icon name="check" size={16} />
            Your password is never stored in plain text.
          </p>
        </form>
      </section>
    </main>
  );
}
